const unsplash = (id, width = 1800) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${width}&q=88`;

const ASSET = "https://customer-assets-39nsmqrw.emergentagent.net/job_last-minute-lux/artifacts/";

// Licensed editorial photography and user-supplied FYLLR service imagery.
export const EDITORIAL_IMAGES = {
  hero: `${ASSET}e42e739ca4267865_Sculptural%20arches%20over%20a%20warm%20thermal%20pool%20%281%29.png`,
  partner: `${ASSET}0cc209a2810b3f6b_Burgundy%20FYLLR%20Storefront%20Teaser.png`,
  join: `${ASSET}f3573e6edce5d932_Sunlit%20mineral%20pool%20bathhouse.png`,
  detail: unsplash("photo-1644162905069-7ed8ee6870f1", 1600),
  architecture: unsplash("photo-1542897284-e3c87555a8d9", 1600),
  portraitAlt: unsplash("photo-1591570849108-af4276674472", 1400),
};

export const SERVICE_IMAGES = {
  hair: `${ASSET}6691c1fae2d734cf_Glossy%20hair%2C%20crafted%20blow-dry.png`,
  nails: `${ASSET}d124f5a797014d60_Warm%20Burgundy%20Manicure%20in%20Progress.png`,
  lashes: `${ASSET}31626dd8b5e677c9_Precision%20lash%20extensions%20in%20warm%20light.png`,
  sauna: `${ASSET}68d176551e5bbb7a_Warm%20Cedar%20Finnish%20Sauna%20Retreat.png`,
  skin: "https://images.unsplash.com/photo-1555820585-c5ae44394b79?auto=format&fit=crop&w=1400&q=88",
  grooming: "https://images.unsplash.com/photo-1747832802200-7aaceb517e0c?auto=format&fit=crop&w=1400&q=88",
  featureWellness: `${ASSET}3c513aa33dd01d24_Quiet%20luxury%20in%20a%20travertine%20bathhouse-3.png`,
  featureGrooming: `${ASSET}cadfe2682a758ba3_Precision%20taper%20at%20the%20barbershop-2.png`,
  featureBeauty: `${ASSET}bef025b73f366725_Luxury%20facial%20serum%20treatment-1.png`,
};
